export default __webpack_public_path__ + "assets/webgl/Suzanne_MetallicRoughness.20a6b529.png";